// ============================================================
// Student Fee Assignments API
// ============================================================

import client from './axios';

export const studentFeeAssignmentsApi = {
  /**
   * Get list of student fee assignments for a school
   */
  getAssignments: async (schoolId, skip = 0, limit = 100) => {
    const response = await client.get('/student-fee-assignment', {
      params: {
        school_id: schoolId,
        skip,
        limit,
      },
    });
    return response.data;
  },

  /**
   * Get single student fee assignment by ID
   */
  getAssignmentById: async (schoolId, id) => {
    const response = await client.get(`/student-fee-assignment/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Create a new student fee assignment
   */
  createAssignment: async (schoolId, payload) => {
    const response = await client.post('/student-fee-assignment', payload, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },

  /**
   * Get assignable fee structures for a school
   */
  getAssignableStructures: async (schoolId, skip = 0, limit = 100) => {
    const response = await client.get('/student-fee-assignment/get-assignable-structures', {
      params: {
        school_id: schoolId,
        skip,
        limit,
      },
    });
    return response.data;
  },

  /**
   * Delete a student fee assignment by ID
   */
  deleteAssignment: async (schoolId, id) => {
    const response = await client.delete(`/student-fee-assignment/${id}`, {
      params: {
        school_id: schoolId,
      },
    });
    return response.data;
  },
};
